import { createFileRoute } from "@tanstack/react-router";

import { PraxaAutomationCatalog } from "../components/praxa/PraxaAutomationCatalogSurface";

export const Route = createFileRoute("/w/$workspaceId/schedule/")({
  component: PraxaScheduleRoute,
});

function PraxaScheduleRoute() {
  const { workspaceId } = Route.useParams();
  return <PraxaAutomationCatalog view="schedule" workspaceId={workspaceId} />;
}
